<script setup lang="ts">
import type { DateRangePickerFieldValue } from '@/components/pickerFields/DateRangePickerField.vue';

import { reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KTextField from '@/components/fields/KTextField.vue';
import DateRangePickerField from '@/components/pickerFields/DateRangePickerField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  jobIds?: string | null;
  dates?: DateRangePickerFieldValue | null;
}

export interface ValidData {
  jobIds: string;
  dates: DateRangePickerFieldValue;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
  isJobIds?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
  isJobIds: false,
});
const emit = defineEmits<{
  submit: [formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData);
});

function customRequiredValidationRule(value: unknown): boolean | string {
  if (!formData.jobIds?.length && !props.isJobIds) {
    return requiredValidationRule(value);
  }
  return true;
}
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.jobIdSearchSearchForm"
    data-testid="jobIdSearchSearchForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-model="formData.jobIds"
      size="lg"
      label="Job IDs"
      :disabled="props.loading"
      :rules="[customRequiredValidationRule]"
      :class="$style.field"
      placeholder="Enter Job IDs"
      clearable
    />
    <DateRangePickerField
      v-model="formData.dates"
      size="lg"
      label="Date range"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <KBtn
      type="submit"
      size="lg"
      prepend-icon="mdi-magnify"
      :loading="props.loading"
      :class="$style.submit"
    >
      Search
    </KBtn>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.jobIdSearchSearchForm {
}
  .field {
    width: 17.5rem;
    display: inline-block;
    vertical-align: top;
  }
  .field {
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .submit {
    margin-bottom: calc(0.5rem + 22px);
  }
</style>
